import { createGroupHeaderAccessor, createPivotAccessorByGrouping } from './pivotAccessors'

export const generateGroupingPivotColumns = (pivotValues, pivotAccessor, pivotValueAccessor, format, align, width, getSubRows, enableColumnGrouping) => {
  const hasNestedStructure = pivotValues.some(meta => meta.children && meta.children.length > 0)

  if (hasNestedStructure && enableColumnGrouping) {
    const [parentGrouping, childGrouping] = Array.isArray(pivotAccessor) ? pivotAccessor : [pivotAccessor]

    return pivotValues.map(parent => {
      const { value: parentValue, displayName: parentDisplayName, children } = parent

      if (!children || children.length === 0) {
        return {
          header: parentDisplayName || parentValue,
          accessor: createPivotAccessorByGrouping(pivotValueAccessor, parentGrouping, getSubRows, parentValue, parentDisplayName),
          accessorKey: `pivot_${String(parentValue).replace(/[^a-zA-Z0-9]/g, '_')}`,
          format: format || 'number',
          align: align || 'right',
          width: width,
          meta: { pivotValue: parentValue, pivotDisplayName: parentDisplayName }
        }
      }

      const groupId = `pivot_group_${String(parentValue).replace(/[^a-zA-Z0-9]/g, '_')}`
      const childColumns = children.map((child, index, array) => {
        return {
          header: child.displayName || child.value,
          accessor: createPivotAccessorByGrouping(pivotValueAccessor, childGrouping, getSubRows, child.value, child.displayName),
          accessorKey: `pivot_${String(child.value).replace(/[^a-zA-Z0-9]/g, '_')}`,
          format: format || 'number',
          align: align || 'right',
          width: width,
          parentGroupId: groupId,
          headerClasses: '__pivot-child',
          cellClasses: '__pivot-child',
          isFirstInGroup: index === 0,
          isLastInGroup: index === array.length - 1,
          meta: {
            pivotValue: child.value,
            pivotDisplayName: child.displayName,
            parentValue: parentValue,
            parentDisplayName: parentDisplayName
          }
        }
      })

      return [
        {
          header: parentDisplayName || parentValue,
          accessor: createGroupHeaderAccessor(pivotValueAccessor, parentGrouping, getSubRows, parentValue, parentDisplayName),
          accessorKey: groupId,
          format: format || 'number',
          align: align || 'right',
          width: width,
          isGroup: true,
          groupId: groupId,
          children: childColumns.map(c => c.accessorKey),
          isCollapsible: true,
          headerClasses: '__pivot-parent',
          cellClasses: '__pivot-parent',
          meta: { isGroup: true, pivotValue: parentValue, pivotDisplayName: parentDisplayName }
        },
        ...childColumns
      ]
    }).flat()
  }

  const groupingLevel = Array.isArray(pivotAccessor)
    ? pivotAccessor[pivotAccessor.length - 1]
    : pivotAccessor

  return pivotValues.map(meta => ({
    header: meta.displayName || meta.value,
    accessor: createPivotAccessorByGrouping(pivotValueAccessor, groupingLevel, getSubRows, meta.value, meta.displayName),
    accessorKey: `pivot_${String(meta.value).replace(/[^a-zA-Z0-9]/g, '_')}`,
    format: format || 'number',
    align: align || 'right',
    width,
    meta: { pivotValue: meta.value, pivotDisplayName: meta.displayName }
  }))
}
